const hostname = window.location.hostname;

export const environment =
  process.env.NODE_ENV === 'development'
    ? { apiUrl: 'http://127.0.0.1:8000' } // local dev
    : hostname.includes('staging')
      ? { apiUrl: 'https://dev.empregamecanico.com.br' } // staging (branch develop)
      : { apiUrl: 'https://api.empregamecanico.com.br' }; // produção (branch main)